import type { Booking, BookingStatus } from '@coachapp/shared';

export const STATUS_ORDER: BookingStatus[] = ['PENDING', 'CONFIRMED', 'COMPLETED', 'CANCELLED'];

export function startOfDay(date: Date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function isSameDay(a: Date, b: Date) {
  return a.toDateString() === b.toDateString();
}

export function computeDashboardAnalytics(
  bookings: Booking[],
  clients: { status: string }[],
  locale: string,
) {
  const now = new Date();
  const today = startOfDay(now);
  const weekStart = new Date(today);
  weekStart.setDate(weekStart.getDate() - 6);

  const activeClients = clients.filter((c) => c.status === 'ACTIVE').length;
  const inactiveClients = clients.filter((c) => c.status === 'INACTIVE').length;
  const todaySessions = bookings.filter((b) => isSameDay(new Date(b.startsAt), today)).length;
  const rangeEnd = new Date(weekStart);
  rangeEnd.setDate(rangeEnd.getDate() + 7);
  const weekSessions = bookings.filter((b) => {
    const d = new Date(b.startsAt);
    return d >= weekStart && d < rangeEnd;
  }).length;
  const pendingCount = bookings.filter((b) => b.status === 'PENDING').length;

  const last7Days = Array.from({ length: 7 }, (_, i) => {
    const day = new Date(weekStart);
    day.setDate(weekStart.getDate() + i);
    const count = bookings.filter((b) => isSameDay(new Date(b.startsAt), day)).length;
    return { day, count };
  });
  const maxDayCount = Math.max(1, ...last7Days.map((d) => d.count));

  const statusCounts = STATUS_ORDER.map((status) => ({
    status,
    count: bookings.filter((b) => b.status === status).length,
  }));
  const totalBookings = bookings.length || 1;

  const upcoming = bookings
    .filter((b) => b.status !== 'CANCELLED' && new Date(b.startsAt) >= now)
    .sort((a, b) => new Date(a.startsAt).getTime() - new Date(b.startsAt).getTime())
    .slice(0, 5);

  return {
    activeClients,
    inactiveClients,
    todaySessions,
    weekSessions,
    pendingCount,
    last7Days,
    maxDayCount,
    statusCounts,
    totalBookings,
    upcoming,
    locale,
    weekStart,
    today,
  };
}
